import { keyframes, css } from 'styled-components'

const fadeInAndOut = keyframes`
  from {
    opacity: 0;
  }

  44% {
    opacity: .5;
  }

  60% {
    opacity: .5;
  }

  to {
    opacity: 0;
  }
`

const animation = css`
  animation: ${fadeInAndOut} 1700ms cubic-bezier(0.87, 0, 0.13, 1); /* easeInOutExpo */
`

export default animation
